/**
 * Convert a Monaco editor signature help trigger kind to an LSP signature help trigger kind.
 *
 * @param signatureHelpTriggerKind
 *   The Monaco signature help trigger kind to convert.
 * @returns
 *   The signature help trigger kind as an LSP signature help trigger kind.
 */
export function fromSignatureHelpTriggerKind(signatureHelpTriggerKind) {
    return signatureHelpTriggerKind;
}
/**
 * Convert an LSP signature help trigger kind to a Monaco editor signature help trigger kind.
 *
 * @param signatureHelpTriggerKind
 *   The LSP signature help trigger kind to convert.
 * @returns
 *   The signature help trigger kind as Monaco editor signature help trigger kind.
 */
export function toSignatureHelpTriggerKind(signatureHelpTriggerKind) {
    return signatureHelpTriggerKind;
}
//# sourceMappingURL=signatureHelpTriggerKind.js.map